import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { theme } from "../styles/theme";
import Providers from "./providers";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ThemeProvider>
  );
};

export default App;
